


















import {Component, Prop, Mixins} from 'vue-property-decorator'
import {resolveTravelImageMixin} from '@/mixins/resolveImageMixin'
import {ITravel} from '@/entities'

@Component
export default class TravelPreviewCard extends Mixins(resolveTravelImageMixin) {

  @Prop() readonly data!: ITravel
  get travel(): ITravel | null | undefined {
    return this.data;
  }

}
